var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-audio-border",class:{
    f: _vm.$props.isFirst,
    l: _vm.$props.isLast,
    s: _vm.$props.isSelected,
    h: _vm.$props.showDim,
  }})}
var staticRenderFns = []

export { render, staticRenderFns }